/* eslint-disable indent */
import { ViewProposalPage } from 'features/Proposal';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function DetailProposalPage() {
    return (
        <LayoutProvider>
             <Layout
                style={{
                    maxHeight: 'calc(100vh - 9rem)',
                    overflowY: 'auto',
                    borderRadius: '12px',
                    border: '1px solid var(--surface-border)',
                }}
                >
                <ViewProposalPage />
            </Layout>
        </LayoutProvider>
    );
}

export default DetailProposalPage;
